/* Only observes its own five images. Custom element lifecycle supports editor reloads. */
(() => {
  if (customElements.get('mosasaur-why')) return;
  customElements.define('mosasaur-why', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const items = [...this.querySelectorAll('.mos-why__reveal')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!items.length || reduced.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
        this.classList.remove('is-observing');
        items.forEach(item => item.classList.add('is-visible'));
        return;
      }
      // Keep above-the-fold content visible, including during an editor reinsertion.
      items.forEach(item => {
        const bounds = item.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0) item.classList.add('is-visible');
      });
      this.classList.add('is-observing');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      items.forEach(item => this.observer.observe(item));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
